import React,{Component} from 'react'
import moment            from 'moment'
import prettysize        from '../../utils'

import { bindActionCreators } from 'redux'
import { connect }            from 'react-redux'
import { withRouter }         from 'react-router-dom'

import {List, Popconfirm, Button, Icon, Progress, Tooltip}                 from 'antd'
import {XAxis, YAxis, CartesianGrid, ResponsiveContainer, AreaChart, Area} from 'recharts'

import { on_migration_progress,
  clear_migration, refresh_migrations_history
} from "../../actions/migrations"

import {refresh_rm}   from "../../actions/auth"
import TransferStats  from '../../components/ManagedTransfer/Dashboard'

import './styles.scss'

class TransferDashboardLambda extends Component {

  constructor (props){
    super(props)

    this.state = {
      speeds : [...Array(30).keys()].map(_=> ({time: _, cumulative: 0})),

      migration:{},

      migrations:{},

      speed_stat:{
        icon: 'dashboard',
        name: 'Speed',
        value: '0 MB/s'
      },

      transferred_stat:{
        icon: 'hdd',
        name: 'Transferred',
        value: '0 GB'
      },

      remaining_stat:{
        icon: 'hdd',
        name: 'Remaining',
        value: '0 GB'
      },

      history : [],

      feed:{
        percent:0,
        rate:0,
        transferred:0,
        size:0,
      }
    }

    //moment.relativeTimeThreshold('m', 60)
    moment.relativeTimeThreshold('s', 60)
    moment.relativeTimeThreshold('ss', 0)
  }

  componentDidMount() {
    this.props.refresh_migrations_history()
    this.props.refresh_rm()
    this.stats_loop()
  }

  componentWillReceiveProps(props) {
    this.setState({migrations:props.ongoing, history:props.history})
  }

  componentWillUnmount(){
    this.stop_loop = true
  }

  update = () =>{
    let {speed_stat={}, transferred_stat={}, remaining_stat={}, speeds=[], migrations} = this.state

    let total_percent      = 0
    speed_stat.value       = 0
    transferred_stat.value = 0
    remaining_stat.value   = 0

    for (let key in migrations) {
      let {percent, rate, transferred, size, status, updated, failed} = migrations[key]
      if(status !== 'Processing' || ((new Date) - updated) < 60 * 1000)
        continue

      total_percent          += percent||0
      speed_stat.value       += rate||0
      transferred_stat.value += transferred||0
      remaining_stat.value   += (size - transferred)||0
    }

    if(total_percent === 100){
      total_percent          = 0
      speed_stat.value       = 0
      transferred_stat.value = 0
      remaining_stat.value   = 0
    }

    speeds.push({time:Date.now(), cumulative:speed_stat.value*8})

    speed_stat.value       = speed_stat.value > 0 ? (prettysize(speed_stat.value*8).toTitleCase() + 'ps'):'0'
    transferred_stat.value = prettysize(transferred_stat.value)
    remaining_stat.value   = prettysize(remaining_stat.value)

    if(speeds.length > 1000)
      speeds.splice(0, 100)

    this.setState({speed_stat, transferred_stat, remaining_stat, speeds:[...speeds]})
  }

  stats_loop = async () => {
    while (!this.stop_loop) {
      await new Promise(resolve => setTimeout(resolve, 1000))
      this.update(this.state.migration||{})
    }
  }

  clear = migration => this.props.clear_migration(migration, ()=> this.props.refresh_migrations_history())

  render() {
    let {speeds, speed_stat={}, transferred_stat={}, remaining_stat={}, history:{today:today_history=[], yesterday:yesterday_history=[], week:week_history=[]}={}, migrations={}} = this.state
    migrations = Object.values(migrations).filter(m=> m.status=== 'Processing' || m.status=== 'Enqueued' || m.status=== 'Started' || m.status=== 'Failed' || m.status === 'Canceled') //(m=> (m.progress||{}).percent !== 100)
      return <div className='transfer-page'>
          <div className='transfer-stats-container'>
              <TransferStats key={'speed'} {...speed_stat}/>
              <TransferStats key={'done'} {...transferred_stat}/>
              <TransferStats key={'remaining'} {...remaining_stat}/>
          </div>

          <h5 className='transfer-header'>Transfers speed</h5>
          <div className='transfer-chart-container'>
              <SpeedChart speeds={speeds}/>
          </div>

          <div className='transfer-list-container'>
              {
                migrations.length ?
                      <div>
                          <h5 className='transfer-header'>Ongoing transfers</h5>
                          <List
                              itemLayout='vertical' dataSource={migrations}
                              renderItem={(migration = {}, index) => {
                                  const {
                                      cloud: dest_cloud = '', files: items = {}, bucket: dest_bucket_name = '',
                                      status: migration_status
                                  } = migration
                                  let files = Object.values(items) || []
                                  const {cloud} = files[0] || {}

                                  return (
                                      <List.Item>
                                          <List.Item.Meta
                                              title={
                                                  <div>
                                                      <span>{cloud ? (cloud + ' → ' + dest_cloud + ' ' + dest_bucket_name) : ('starting ...')}</span>
                                                      {
                                                          migration_status === 'Processing' ?
                                                              <Popconfirm title="Are you sure to cancel this transfer?"
                                                                          placement="left" key={'2'}
                                                                          onConfirm={e => e.stopPropagation() & this.clear(migration)}
                                                                          okText="Yes" cancelText="No">
                                                                  <Button shape="circle" icon="close" size={'small'} ghost/>
                                                              </Popconfirm> :
                                                              <Button shape="circle" icon="close" size={'small'} key={'2'}
                                                                      ghost
                                                                      onClick={e => e.stopPropagation() & this.clear(migration)}/>
                                                      }
                                                  </div>
                                              }
                                              description={
                                                  (files.map((file, index) => {
                                                          const {bucket, status: file_status, path, percent = 0, rate = 0, succeeded =0, size = 0, count=0, dir_count, started, ended, time_left = 0, error, message: file_message, is_directory, failed} = file
                                                          let status = percent < 100 ? (file_status === 'Failed' ? 'exception' : 'active') : 'success'

                                                          return (
                                                                  <div className='file-item columnWrap' key={index}>
                                                                    {file_status === 'Processing' ?
                                                                        <Icon className={file_status} type="sync"
                                                                              spin/> : ((file_status === 'Failed' || file_status === 'Canceled') ?
                                                                            <Icon className={file_status} type="warning"
                                                                                  theme="outlined"/> : (path ?
                                                                                <Icon className={file_status} type="file-text"/> :
                                                                                <Icon className={file_status} type="folder"/>))}
                                                                    <div>
                                                                      <span>{(path || bucket) + ((percent===0&&count===0&&dir_count===0) ? ' - enqueued' : (file_message ? (' - ' + file_message) : ''))} </span>
                                                                      {
                                                                        file_status === 'Succeeded' ?
                                                                            <span>{`transferred ${prettysize(size)} ${moment.duration((new Date(ended).getTime() - new Date(started).getTime()) / 1000, 'seconds').humanize(true)}`}</span> :
                                                                            ((file_status === 'Processing' || file_status === 'Enqueued') ?
                                                                                <span>
                                                                                  {((time_left > 0 && rate > 0) ? `${prettysize(rate * 8).toTitleCase()}ps - ` : '') + `${prettysize(size)} ${(count + dir_count) > 0 ? ( ' - ' + succeeded + ' of ' + count.toLocaleString() + ' files and ' + dir_count.toLocaleString() + ' directories - ' + failed + ' files failed') : ''} - ${moment.duration(time_left, 'seconds').humanize(true)}`}
                                                                                </span> :
                                                                                <div>
                                                                                  <span
                                                                                    className={`${file_status}-color`}>{'Transfer did not succeed '}
                                                                                  </span>
                                                                                  {` - ${file_message}`}
                                                                                </div>)
                                                                      }
                                                                    </div>
                                                                    {file_status === 'Processing' &&
                                                                    <Progress type='circle' status={status}
                                                                              percent={parseFloat(percent) ? parseFloat(percent) : 0}
                                                                              width={30}/>}
                                                                  </div>
                                                          )
                                                      }
                                                  ))
                                              }
                                          />
                                      </List.Item>
                                  )
                              }}
                          />
                      </div> : null
              }

              {
                  today_history.length ?
                      <div>
                          <h5 className='transfer-header'>Today</h5>
                          <List
                              itemLayout='vertical' dataSource={today_history}
                              renderItem={(item = {}) => (
                                  <List.Item>
                                      <List.Item.Meta
                                          title={
                                              <div>
                                                  <a>{item.cloud + ' → ' + item.destination.cloud + ' ' + item.destination.bucket_name}</a>
                                                  <span>{prettysize(item.size)}</span>
                                              </div>
                                          }
                                          description={
                                              <Tooltip title={moment.utc(item.created).fromNow()}>
                                                  {
                                                      ((item.files || []).map((file, i) =>
                                                          <div key={i} className={'transferred-files'}>
                                                              <Tooltip title={file.status}>
                                                                  <Icon className={file.status} theme="outlined"
                                                                        type={file.status === 'Succeeded' ? 'check' : 'warning'}/>
                                                              </Tooltip>
                                                              <span>{file.bucket_name + '/' + (file.path || '')}</span>
                                                              <span>{file.size ? prettysize(file.size) : ''}</span>
                                                          </div>
                                                      ))
                                                  }
                                              </Tooltip>
                                          }
                                      />
                                  </List.Item>
                              )}
                          />
                      </div> : null
              }

              {
                  yesterday_history.length ?
                      <div>
                          <h5 className='transfer-header'>Yesterday</h5>
                          <List
                              itemLayout='vertical' dataSource={yesterday_history}
                              renderItem={(item = {}) => (
                                  <List.Item>
                                      <List.Item.Meta
                                          title={
                                              <div>
                                                  <a>{item.cloud + ' → ' + item.destination.cloud + ' ' + item.destination.bucket_name}</a>
                                                  <span>{prettysize(item.size)}</span>
                                              </div>
                                          }
                                          description={
                                              <Tooltip title={moment.utc(item.created).fromNow()}>
                                                  {
                                                      ((item.files || []).map((file, i) =>
                                                          <div key={i} className={'transferred-files'}>
                                                              <Tooltip title={file.status}>
                                                                  <Icon className={file.status} theme="outlined"
                                                                        type={file.status === 'Succeeded' ? 'check' : 'warning'}/>
                                                              </Tooltip>
                                                              <span>{file.bucket_name + '/' + (file.path || '')}</span>
                                                              <span>{file.size ? prettysize(file.size) : ''}</span>
                                                          </div>
                                                      ))
                                                  }
                                              </Tooltip>
                                          }
                                      />
                                  </List.Item>
                              )}
                          />
                      </div> : null
              }

              {
                  week_history.length ?
                      <div>
                          <h5 className='transfer-header'>This Week</h5>
                          <List
                              itemLayout='vertical' dataSource={week_history}
                              renderItem={(item = {}) => (
                                  <List.Item>
                                      <List.Item.Meta
                                          title={
                                              <div>
                                                  <a>{item.cloud + ' → ' + item.destination.cloud + ' ' + item.destination.bucket_name}</a>
                                                  <span>{prettysize(item.size)}</span>
                                              </div>
                                          }
                                          description={
                                              <Tooltip title={moment.utc(item.created).fromNow()}>
                                                  {
                                                      ((item.files || []).map((file, i) =>
                                                          <div key={i} className={'transferred-files'}>
                                                              <Tooltip title={file.status}>
                                                                  <Icon className={file.status} theme="outlined"
                                                                        type={file.status === 'Succeeded' ? 'check' : 'warning'}/>
                                                              </Tooltip>
                                                              <span>{file.bucket_name + '/' + (file.path || '')}</span>
                                                              <span>{file.size ? prettysize(file.size) : ''}</span>
                                                          </div>
                                                      ))
                                                  }
                                              </Tooltip>
                                          }
                                      />
                                  </List.Item>
                              )}
                          />
                      </div> : null
              }
          </div>
      </div>
  }
}

export default withRouter(connect(({migrations={}}) => ({ongoing:migrations.ongoing, history:migrations.history}), dispatch => bindActionCreators({on_migration_progress, clear_migration, refresh_migrations_history, refresh_rm}, dispatch))(TransferDashboardLambda))

const SpeedChart = ({ speeds }) => (
  <ResponsiveContainer height = {150}>
    <AreaChart width={730} height={250} data={speeds} margin={{ top: 15, right: 15, left: 0, bottom: 0 }}>
      <defs>
        <linearGradient id="color1" x1="0" y1="0" x2="0" y2="1">
          <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8}/>
          <stop offset="95%" stopColor="#8884d8" stopOpacity={0}/>
        </linearGradient>
        {/*<linearGradient id="color2" x1="0" y1="0" x2="0" y2="1">
          <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8}/>
          <stop offset="95%" stopColor="#82ca9d" stopOpacity={0}/>
        </linearGradient>*/}
      </defs>

      <XAxis dataKey="time" name='Time' domain = {['auto', 'auto']} tickFormatter = {t => moment(t).format('HH:mm')} height={0} tickLine={false} axisLine={false}
             tickCount={100}/>
      <YAxis name='Rate' domain = {['auto', 'auto']} tickCount={4} tickFormatter = {t => t>1024?(prettysize(t).toTitleCase() + 'ps'):''} orientation='right' tickLine={true} axisLine={false}/>

      <CartesianGrid strokeDasharray="1 3" horizontal={true} vertical={false} stroke="gainsboro"/>
      {/*<Tooltip cursor={{strokeDasharray: '3 3'}} aab8c2/>*/}
      <Area type="monotone" dataKey="cumulative" name={'Transfer Rate'} isAnimationActive={false} stroke="#8884d8" fillOpacity={1} fill="url(#color1)"/>
    </AreaChart>
  </ResponsiveContainer>
)
